import WMSLayer from "@arcgis/core/layers/WMSLayer";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import WMTSLayer from "@arcgis/core/layers/WMTSLayer";
import WMSSublayer from "@arcgis/core/layers/support/WMSSublayer";
import { osRoadLayerId, satelliteLayerId,
   osRoadLayerTitle, satelliteLayerTitle, osVectorLayerTitle } from "../../constants/mapLayers";

/**
 * Get the os road map layer
 * @param {*} opacity default is 100
 * @returns 
 */
export function osRoadLayer(opacity = 100){
    return new WMTSLayer({
      title: "OS Road", 
      opacity: opacity, 
      url: "https://api.os.uk/maps/raster/v1/wmts",
      customParameters: {
        key: "f2R9kbtnoPTDmCPAPh119jRYNsHsGZcW",
      },
      activeLayer: {
        id: "Road_27700",
      },
      copyright: '© Crown copyright [and database rights] 2024. OS AC0000815036.'
    })
  };
  
  /**
   * Get the os vector layer
   * @param {*} opacity defaults to 100
   * @returns 
   */
  export function osVectorLayer(opacity = 100) {
    return new VectorTileLayer({
      opacity: opacity,
      url: "https://api.os.uk/maps/vector/v1/vts",
      style: require("../../components/maps/OS_VTS_27700_ESRI.json"),
    })
  }
  
  /**
   * Get the satellite map layer
   * @param {*} opacity defaults to 100
   * @returns 
   */
  export function satelliteLayer(opacity = 100) {
    return new WMSLayer({
      opacity: opacity, 
      url: "https://www.getmapping.com/GmWMS/e1dad920-1adc-4de2-8220-447b9cae17ab/ApgbBng.wmsx",
      sublayers: [
        new WMSSublayer({
          name: "APGB_Latest_UK_250mm"
        })
      ],
      copyright: '© Bluesky International / Getmapping PLC.'
    })
  }

  /**
   * Get the layer title of the selected layer
   * @param {*} mapLayerId 
   * @returns layer title
   */
  export function getLayerText(mapLayerId) {
    if(mapLayerId === osRoadLayerId) {
      return osRoadLayerTitle;
    } else if (mapLayerId === satelliteLayerId) {
      return satelliteLayerTitle;
    } 

    return osVectorLayerTitle; 
  }
